module.exports = __webpack_public_path__ + "static/media/custom-15000-medium.b044b22b.svg";